export * from "./explore-detail-rating-box-card";